// client/src/components/dashboard/settings/SettingsPage.js
import React from 'react';
import { useAuth } from '../../../context/AuthContext'; // Correct relative path
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../common/LoadingSpinner.js';

import './SettingsPage.css'; // Import CSS


function SettingsPage() {
    const { user } = useAuth(); // We still get the user, even if we don't display it yet
    const { t } = useTranslation();

    if (!user) {
        return <LoadingSpinner />; // Use the LoadingSpinner
    }

    return (
        <div className="settings-container">
            <div className="settings-title-container">
                <h1>{t('dashboard.settings.title')}</h1>
            </div>
            <div className="security-details">
                <h2>{t('dashboard.settings.security.title')}</h2>
                <p>This is some demo text inside the profile details div.</p>
            </div>
            <div >
                &copy; {new Date().getFullYear()} beinSmart.cloud. {t('footer.allRightsReserved')}
            </div>
        </div>
    );
}

export default SettingsPage;